import { render, staticRenderFns } from "./TranslationCard.vue?vue&type=template&id=5de94336&scoped=true"
import script from "./TranslationCard.vue?vue&type=script&lang=js"
export * from "./TranslationCard.vue?vue&type=script&lang=js"
import style0 from "./TranslationCard.vue?vue&type=style&index=0&id=5de94336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de94336",
  null
  
)

export default component.exports